
// ======================================================
// callback for option_selection.js
// ======================================================
// The following will have to be in your product template (without the comments wrapping it!) to initialize the option_selection.js

/* ====================== tricky3.infinite-scroll.v2.min.js ======================== */

var __extends = this && this.__extends || function(e, t) {
        function i() {
            this.constructor = e
        }
        for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
        e.prototype = null === t ? Object.create(t) : (i.prototype = t.prototype, new i)
    },
    t3PageLoadHelpers;
! function(e) {
    e.loadImages = function(e, t) {
        var i = this,
            n = $("img", e).length,
            s = 1,
            o = !1;
        n.length ? $("img", e).load(function() {
            ++s >= n && i.isRequestOn && !o && (t(e), o = !0)
        }).each(function() {
            this.complete && $(this).load()
        }) : t(e)
    }, e.savePageState = function(t) {
        if (void 0 === t && (t = {
                key: "",
                value: ""
            }), history.pushState) {
            var i = "",
                n = t.key,
                s = t.value;
            if (e.isQueryStringKeyInUrl(n)) i = e.updateQueryStringParameter(window.location.href, n, encodeURIComponent(s));
            else {
                var o = n + "=" + encodeURIComponent(s);
                o = "" != window.location.search ? window.location.search + "&" + o : "?" + o, i = window.location.protocol + "//" + window.location.host + window.location.pathname + o
            }
            i += window.location.hash, window.history.pushState({
                path: i
            }, "", i)
        } else console.log("History pushstate not supported")
    }, e.getQueryStringByKey = function(e, t) {
        void 0 === t && (t = ""), e = e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var i = new RegExp("[\\?&]" + e + "=([^&#]*)"),
            n = t ? i.exec(t) : i.exec(location.search);
        return null == n ? "" : decodeURIComponent(n[1].replace(/\+/g, " "))
    }, e.isQueryStringKeyInUrl = function(e) {
        return -1 != location.search.indexOf(e)
    }, e.updateQueryStringParameter = function(e, t, i) {
        var n = new RegExp("([?&])" + t + "=.*?(&|$)", "i"),
            s = -1 !== e.indexOf("?") ? "&" : "?";
        return e.match(n) ? e.replace(n, "$1" + t + "=" + i + "$2") : e + s + t + "=" + i
    }, e.removeQueryStringParameter = function(e, t) {
        var i = e.split("?");
        if (i.length >= 2) {
            for (var n = encodeURIComponent(t) + "=", s = i[1].split(/[&;]/g), o = s.length; o-- > 0;) - 1 !== s[o].lastIndexOf(n, 0) && s.splice(o, 1);
            return e = i[0] + "?" + s.join("&")
        }
        return e
    }
}(t3PageLoadHelpers || (t3PageLoadHelpers = {})),
function(e) {
    var t = function() {
            function t(i, n) {
                this.isRequestOn = !1, this.currentLink = null, this.bothNextAndPreviousAvailableOnLoad = !1, this.links = {
                    next: "next",
                    previous: "previous"
                }, this.hasAllPagesLoaded = !1, this.element = i, this.settings = e.extend(t.defaultSettings, n), this.itemsWrapper = e(this.settings.selectors.itemsWrapper), this.paginationWrapper = e(this.settings.selectors.paginationWrapper), this.bothNextAndPreviousAvailableOnLoad = e(this.settings.selectors.nextPageLink, this.paginationWrapper).length && e(this.settings.selectors.previousPageLink, this.paginationWrapper).length
            }
            return t.prototype.getPage = function(t, i) {
                var n = this;
                this.isRequestOn || e.ajax({
                    url: t,
                    type: "get",
                    beforeSend: function() {
                        n.isRequestOn = !0, "function" == typeof n.settings.callBacks.beforePageLoad && n.settings.callBacks.beforePageLoad()
                    },
                    success: function(e) {
                        i(e)
                    }
                })
            }, t.defaultSettings = {
                selectors: {
                    itemsWrapper: ".collection-matrix",
                    item: "li",
                    nextPageLink: "#NextPaginationLink a",
                    previousPageLink: "#PreviousPaginationLink a",
                    paginationWrapper: ".pagination",
                    scrollableElem: null
                },
                manualLoading: !1,
                pageQueryStringKey: "page",
                waitForImagesToBeLoaded: !1,
                enablePageState: !1,
                throttleDelay: 100,
                callBacks: {
                    onAllPagesLoaded: function() {},
                    onPageLoad: function(e) {},
                    beforePageLoad: function() {}

                }
            }, t
        }(),
        i = function(t) {
            function i(e, i) {
                t.call(this, e, i)
            }
            return __extends(i, t), i.prototype.init = function() {
                this._bindEvents()
            }, i.prototype._bindEvents = function() {
                var t = this;
                this.paginationWrapper.on("click", this.settings.selectors.nextPageLink, function(i) {
                    i.preventDefault(), t.linkedClicked = t.links.next, t.currentLink = e(this).attr("href"), t.getPage(t.currentLink, function(e) {
                      feather.replace(); 
                      t._pageLoadedSuccess(e)
                    })
                }), this.paginationWrapper.on("click", this.settings.selectors.previousPageLink, function(i) {
                    i.preventDefault(), t.linkedClicked = t.links.previous, t.currentLink = e(this).attr("href"), t.getPage(t.currentLink, function(e) {
                      feather.replace(); 
                      t._pageLoadedSuccess(e)
                    })
                })
            }, i.prototype._updateNextAndPreviousLinks = function(t) {
                var i = t.find(this.settings.selectors.nextPageLink),
                    n = t.find(this.settings.selectors.previousPageLink),
                    s = e(this.settings.selectors.nextPageLink, this.paginationWrapper),
                    o = e(this.settings.selectors.previousPageLink, this.paginationWrapper),
                    a = !0,
                    r = !0;
                this.bothNextAndPreviousAvailableOnLoad && (this.linkedClicked == this.links.previous && (a = !1), this.linkedClicked == this.links.next && (r = !1)), a = s.length && a, r = o.length && r, a && (i.length ? s.replaceWith(i) : s.remove()), r && (n.length ? o.replaceWith(n) : o.remove()), this.hasAllPagesLoaded = !e(this.settings.selectors.nextPageLink, this.paginationWrapper).length && !e(this.settings.selectors.previousPageLink, this.paginationWrapper).length
            }, i.prototype._pageLoadedSuccess = function(t) {
                var i = this,
                    n = e(t),
                    s = n.find(this.settings.selectors.item);
                this._updateNextAndPreviousLinks(n), this.settings.waitForImagesToBeLoaded ? t3PageLoadHelpers.loadImages(s, function(e) {
                    i._processingComplete(e)
                }) : this._processingComplete(s)
            }, i.prototype._processingComplete = function(t) {
                if (this.itemsWrapper.append(e("<div/>").append(t).html()), this.settings.enablePageState) {
                    var i = this.currentLink,
                        n = t3PageLoadHelpers.getQueryStringByKey(this.settings.pageQueryStringKey, i);
                    t3PageLoadHelpers.savePageState({
                        key: this.settings.pageQueryStringKey,
                        value: n
                    })
                }
                "function" == typeof this.settings.callBacks.onPageLoad && this.settings.callBacks.onPageLoad(t), this.hasAllPagesLoaded && "function" == typeof this.settings.callBacks.onAllPagesLoaded && this.settings.callBacks.onAllPagesLoaded(), this.isRequestOn = !1
            }, i
        }(t),
        n = function(t) {
            function i(i, n) {
                t.call(this, i, n), this.scrollTimer = 0, this.resizeTimer = 0, this.linkedLoaded = null, this.nextPageLink = null, this.previousPageLink = null, this.scrollableElement = e(this.settings.selectors.scrollableElem ? this.settings.selectors.scrollableElem : window)
            }
            return __extends(i, t), i.prototype.init = function() {
                var e = this;
                this._loadLinks(), this.scrollableElement.on("scroll", function(t) {
                    i.throttle(function(t) {
                        e.isRequestOn || e._scrollEventHandler()
                    }, e.settings.throttleDelay)()
                })
            }, i.prototype._loadLinks = function() {
                this.nextPageLink = e(this.settings.selectors.nextPageLink, this.paginationWrapper), this.previousPageLink = e(this.settings.selectors.previousPageLink, this.paginationWrapper)
            }, i.prototype._scrollEventHandler = function() {
                var e = this;
                requestAnimationFrame(function() {
                    e._trickyInfiniteScroll()
                })
            }, i.prototype._trickyInfiniteScroll = function() {
                var t = this,
                    i = e(this.scrollableElement).scrollTop() + e(this.scrollableElement).height(),
                    n = e(this.settings.selectors.item + ":visible:last", this.element);
                if ((n.length ? n.offset().top : e(this.settings.selectors.item + ":last", this.element).offset().top) + e(this.settings.selectors.item + ":visible:last", this.element).height() <= i && this.nextPageLink) {
                    var s = this.nextPageLink.attr("href");
                    this.getPage(s, function(e) {
                        t._pageLoadedSuccess(e)
                    })
                } else this.isRequestOn = !1, this.nextPageLink || (e(this.settings.selectors.nextPageLink, this.paginationWrapper).remove(), this.hasAllPagesLoaded || (this.hasAllPagesLoaded = !0, "function" == typeof this.settings.callBacks.onAllPagesLoaded && this.settings.callBacks.onAllPagesLoaded()))
            }, i.prototype._updateNextAndPreviousLinks = function(e) {
                var t = e.find(this.settings.selectors.nextPageLink);
                e.find(this.settings.selectors.previousPageLink);
                t.length ? this.nextPageLink = t : this.nextPageLink = null
            }, i.prototype._pageLoadedSuccess = function(t) {
                var i = this,
                    n = e(t),
                    s = n.find(this.settings.selectors.item);
                this._updateNextAndPreviousLinks(n), this.settings.waitForImagesToBeLoaded ? t3PageLoadHelpers.loadImages(s, function(e) {
                    i._processingComplete(e)
                }) : this._processingComplete(s)
            }, i.prototype._processingComplete = function(t) {
                this.itemsWrapper.append(e("<div/>").append(t).html()), "function" == typeof this.settings.callBacks.onPageLoad && this.settings.callBacks.onPageLoad(t), this.isRequestOn = !1
            }, i.prototype._unbindScrollingEvent = function() {}, i.throttle = function(e, t) {
                void 0 === t && (t = 10);
                var n, s, o = !1,
                    a = function() {
                        o = !1, e.apply(n, s)
                    };
                return function() {
                    n = this, s = arguments, o || (o = !0, setTimeout(a, t || i.SCROLL_THROTTLE_DEFAULT_DELAY))
                }
            }, i.scrollEventHandlerFuncName = "_scrollEventHandler", i.SCROLL_THROTTLE_DEFAULT_DELAY = 500, i
        }(t);
    e.fn.t3PageLoad = function(t) {
        var s = null;
        return (s = t.manualLoading ? new i(e(this), t) : new n(e(this), t)).init(), s
    }
}(jQuery);
/* ======================= ajax pagination ================== */


(function($) {
  $(document).ready(function() {
    wst.go()
  });
  var wst = {
    atTimeout: null,
    go: function() {
      this._scrollTop();
      this._infinitescrolling();
      feather.replace();
    },

    _infinitescrolling: function() {
       feather.replace();
       if ($(".infinite-scrolling").length > 0) {
        $(".loading-product").hide();
        $(".infinite-scrolling a").click(function(n) {
          n.preventDefault();
          if (!$(this).hasClass("disabled")) {
            wst.doInfiniteScrolling()
          }
        })
      }
    },
    doInfiniteScrolling: function() {
      
      var n = $(".collection-wrapper .product-wrapper-grid");

      var j = $('.product-top-filter .collection-grid-view');

      if (!n.length) {
        n = $(".collection-wrapper .product-wrapper-grid.list-section")
      }
      if (n) {
        var r = $(".infinite-scrolling a").first();
        $.ajax({
          type: "GET",
          url: r.attr("href"),
          beforeSend: function() {
            $(".loading-product").show();
            feather.replace();
          },
          success: function(i) {
            wst.hideLoading();
            $(".loading-product").hide();
            var s = $(i).find(".collection-wrapper .product-wrapper-grid");
            if (!s.length) {
              s = $(i).find(".collection-wrapper .product-wrapper-grid .col-lg-12")
            }
            if (s.length) {
              if (s.hasClass("product-wrapper-grid")) {
                if (window.product_image_resize) {
                  s.children().find("img").fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".product-wrapper-grid .product-slide .img-box",
                    ratioWrapper: window.images_size
                  })
                }
              }
              n.append(s.children());
              if ($(i).find(".infinite-scrolling").length > 0) {
                r.attr("href", $(i).find(".infinite-scrolling a").attr("href"))
              } else {
                r.hide();
                r.next().show()
              }
              if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges()
              }
            }
          },
          error: function(n, r) {
            wst.hideLoading();
            $(".loading-product").hide();
            $(".ajax-error-message").text($.parseJSON(n.responseText).description);
            wst.showModal(".ajax-error-modal")
          },
          complete: function() {
            $(j).find(".active img").trigger('click');
            $(".coll_sidebar, .collection-content").stick_in_parent();
          },
          dataType: "html"
        })
      }
    },

    _sidebargetContent: function(n) {
      $.ajax({
        type: "get",
        url: n,
        beforeSend: function() {
          wst.showLoading();
          $('.collection_ajax_loader').show();
        },
        success: function(e) {
          $('.collection_ajax_loader').hide();
          wst._infinitescrolling();
        },
        error: function(n, cart) {
          wst.hideLoading();
          $(".loading-modal").hide();
          $('.collection_ajax_loader').hide();
          $(".ajax-error-message").text($.parseJSON(n.responseText).description);
          wst.showModal(".ajax-error-modal")
        }
      })
    },

    _scrollTop: function() {
      $("#back-top").click(function() {
        $("body,html").animate({
          scrollTop: 0
        }, 400);
        return false
      })
    },
    showLoading: function() {
      $(".loading").show()
    },
    hideLoading: function() {
      $(".loading").hide()
    },

  }

  })(jQuery);
/* ================ compare ==================== */

var shop_currency_val = $('#shop-currency').text();

(function($) {
  /* Compare Product */
  var storage = localStorage;
  var compare = {};
  var total_compare = 4;

  if (storage.getItem('compare') !== null) {
    compare = JSON.parse(storage.getItem('compare'));
  } else {
    storage.setItem('compare', JSON.stringify(compare));
  }

  $(document).ready(function() {
    init();
  });

  function showModal(selector) {
    $(selector).fadeIn(500);
  
    var compareTable = compare_to_table(compare);
    $(selector + ' #table-compare').html(compareTable);
  }

  function init() {
    initCompare();
    initRemoveCompare();
    initModal();
  }

  function initModal() {
    $(".close-modal").click(function() {
      $(".compare_modal").hide();
    });
  }

  function compare_to_table(data) {
    var end_check = (Object.keys(data).length - 1);
    var width_tr = (end_check > 0) ? (85 / (Object.keys(data).length)) : 90;
    if (Object.keys(data).length <= 0) {
      return '';
    }
  
    var html = '';
  
    // Add the row for titles
    html += '<tr>';
    html += '<th width=15%" class="title-cell">Title</th>';
    for (var key in data) {
      var el = data[key];
      html += '<td width="' + width_tr + '%" class="title-cell"><a href="' + el.handle_url + '" class="text-title">' + el.title + '</a></td>';
    }
    html += '</tr>';
  
    // Add the row for product images
    html += '<tr>';
    html += '<th width=15%" class="image-cell">Image</th>';
    for (var key in data) {
      var el = data[key];
      html += '<td width="' + width_tr + '%" class="image-cell"><a href="' + el.handle_url + '" class="compare-image"><img src="' + el.img_url + '" width="180px" alt="' + el.title + '"></td>';
    }
    html += '</tr>';
  
    // Add the row for prices
    html += '<tr>';
    html += '<th width=15%" class="price-cell">Price</th>';
    for (var key in data) {
      var el = data[key];
      var priceHtml = '<span class="sale-price">' + el.sale_price + '</span>';
      html += '<td width="' + width_tr + '%" class="price-cell price text-content">' + priceHtml + '</td>';
    }
    html += '</tr>';
    
    // Add the row for availibility
    html += '<tr>';
    html += '<th width=15%" class="title-cell">Availibility</th>';
    for (var key in data) {
      var el = data[key];
      html += '<td width="' + width_tr + '%" class="title-cell">' + el.availibility + '</td>';
    }
    html += '</tr>';
    
    // Add the row for type
    html += '<tr>';
    html += '<th width=15%" class="title-cell">Type</th>';
    for (var key in data) {
      var el = data[key];
      html += '<td width="' + width_tr + '%" class="title-cell">' + el.product_type + '</td>';
    }
    html += '</tr>';
    
    // Add the row for rating
    html += '<tr>';
    html += '<th width=15%" class="title-cell">Rating</th>';
    for (var key in data) {
      var el = data[key];
      html += '<td width="' + width_tr + '%" class="title-cell">' + el.product_rating + '</td>';
    }
    html += '</tr>';
    
    // Add the row for cart button
    html += '<tr>';
    html += '<th width=15%" class="title-cell">Purchase</th>';
    for (var key in data) {
      var el = data[key];
      html += '<td width="' + width_tr + '%" class="title-cell"><a href = "'+ el.cart_url +'" class="btn btn-animation btn-sm w-100">Add To Cart</a></td>';
    }
    html += '</tr>';
  
    // Add the header row for action
    html += '<tr>';
    html += '<th width=15%" class="action-cell">Action</th>';
    for (var key in data) {
      html += '<td width="' + width_tr + '%"><a href="javascript:void(0);" class="compare_remove text-content" data-pid="' + key + '"><i class="fa-solid fa-trash-can me-2"></i>Remove</a></td>'; // Add empty cells for other product information
    }
    html += '</tr>';
    
    return html;
  }
  
  
  function initCompare() {
    $(".compare-button").click(function() {
      var pid = $(this).data("pid");
      var compare_count = Object.keys(compare).length;
  
      if (compare_count === total_compare) {
        $.notify({
          message: 'You can only compare up to ' + total_compare + ' products.',
          icon: 'fas fa-exclamation-triangle',
          animate: {
            enter: 'animate__fadeInDown',
            exit: 'animate__fadeOutUp'
          },
        }, 
        {
          type: 'warning',
          placement: {
            from: 'top',
            align: 'left'
          },
          z_index: 2000,
          delay: 2000,
          onClose: function() {
            showModal("#moda-compare"); // Show the comparison modal after the popup is closed
          }
        });
        return false;
      }
  
      var obj = {};
      var p = $(this).closest('.cp_product_box');
      var img = p.find(".cp_product_image img");
      var title = p.find('.cp_product_title').text();
      var handle_url = p.find(".cp_product_image a").attr("href");
      var cart_url = p.find(".cp_product_cart").attr("href");
      var is_sale = p.find(".cp_product_rating").length > 0;
  
      var sale_price = p.find(".cp_product_price").text();
      var sale_price_val = p.find("cp_product_price .money").attr("data-currency-usd");
      var regular_price = p.find(".text-content del").text();
      var regular_price_val = p.find(".text-content del .money").attr("data-currency-usd");
      var availibility = p.find(".cp_product_availibility").text();
      var product_type = p.find(".cp_product_type").text();
      var product_rating = p.find(".cp_product_rating").text();
      var img_url = img.attr("src");
  
      obj = {
        title: title,
        handle_url: handle_url,
        cart_url: cart_url,
        img_url: img_url,
        is_sale: is_sale,
        sale_price: sale_price,
        sale_price_val: sale_price_val,
        regular_price: regular_price,
        regular_price_val: regular_price_val,
        availibility: availibility,
        product_type: product_type,
        product_rating: product_rating,
        key: pid,
      };
  
      if (compare.hasOwnProperty(pid)) {
        $.notify({
          message: 'This product already in your compare list.',
          icon: 'fas fa-exclamation-triangle',
          animate: {
            enter: 'animate__fadeInDown',
            exit: 'animate__fadeOutUp'
          },
        }, 
        {
          type: 'warning',
          placement: {
            from: 'top',
            align: 'left'
          },
          z_index: 2000,
          delay: 2000,
          onClose: function() {
            showModal("#moda-compare"); // Show the comparison modal after the popup is closed
          }
        });
        return false;
      }
  
      compare[pid] = obj;
      storage.setItem("compare", JSON.stringify(compare));
      showModal("#moda-compare");
      $("#table-compare").html(compare_to_table(compare));
    });
  }  
  

  function initRemoveCompare() {
    $(document).on("click", ".compare_remove", function() {
      var pid = $(this).data("pid");

      if (compare.hasOwnProperty(pid)) {
        delete compare[pid];
        storage.setItem("compare", JSON.stringify(compare));
      }

      showModal("#moda-compare");
      $("#table-compare").html(compare_to_table(compare));
    });
  }

})(jQuery);

    
  







